import React from 'react';
import buildUrl from './buildUrl';
import {List} from 'immutable';
import connectToStores from 'alt-utils/lib/connectToStores';
import UserStore from 'stores/UserStore';
import DashboardSidebar from 'components/pure/admin/DashboardSidebar';
import {BullseyeIcon} from '@components/icon/BullseyeIcon';
import {ChartLineUpIcon} from '@components/icon/ChartLineUpIcon';
import {PhoneIcon} from '@components/icon/PhoneIcon';
import {MemoIcon} from '@components/icon/MemoIcon';

const sidebarMenu = props => {
  const {manager, sessionUser} = props;
  const otherUserView = manager && !(manager.id === sessionUser.id);
  const usingI360Embed = sessionUser.i360Embed;

  const path = buildUrl(props);
  const callChildren = List([
    {
      name: 'Rep Activity',
      url: `${path}/rep-activity`,
    },
    {
      name: 'Topics',
      url: `${path}/topics`,
    },
    {
      name: 'Today’s Conversations',
      url: `${path}/todays-conversations`,
    },
    {
      name: 'Conversation Styles',
      url: `${path}/call-metrics`,
    },
  ]);

  const coachingChildren = List([
    {
      name: 'Coaching Effectiveness',
      url: `${path}/coaching-effectiveness`,
    },
    {
      name: 'Rep Skills',
      url: `${path}/rep-skills`,
    },
    {
      name: 'Coaching Plans',
      url: `${path}/coaching-plans`,
    },
    {
      name: `${otherUserView ? manager.firstNamePossessive : 'Your'} Coaching`,
      url: `${path}/your-coaching`,
    },
    {
      name: 'Self Review',
      url: `${path}/self-review`,
    },
    {
      name: 'Peer Coaching',
      url: `${path}/peer-coaching`,
    },
    {
      name: 'Other Coaching',
      url: `${path}/other-coaching`,
    },
  ]);

  return List([
    {
      name: 'Summary',
      icon: MemoIcon,
      url: `${path}/summary`,
    },
    !usingI360Embed && {
      name: 'Activity & Topics',
      icon: PhoneIcon,
      children: callChildren,
    },
    {
      name: 'Coaching',
      icon: ChartLineUpIcon,
      children: coachingChildren,
    },
    props.showKpiTab && {
      name: 'KPIs',
      icon: BullseyeIcon,
      url: `${buildUrl(props)}/kpi`,
    },
  ]).filter(x => x);
};

@connectToStores
export default class ManagerDashboardSidebar extends React.Component {
  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores(props) {
    return {
      manager: UserStore.getState().users.get(props.managerId),
    };
  }

  render() {
    return (
      <DashboardSidebar
        sidebarMenu={sidebarMenu(this.props)}
        sidebarOpen={this.props.sidebarOpen}
        className="dashv2-mgr"
      />
    );
  }
}
